export default class Remove_field_with_error {
  constructor() {
    this.selector = '[data-error-message], [data-field=with-error] input:not([autocomplete=off]), [data-field=with-error] select, [data-field=with-error] textarea'
  }

  init() {
    document.addEventListener('change', this.#handleChange)
  }

  #handleChange = (event) => {
    if (event.target.matches(this.selector)) {
      this.#remove(event.target)
    }
  }

  #remove(target) {
    const errorId = target.dataset.errorMessage || target.getAttribute('id')
    while (target.closest('.field_with_errors')) {
      const errorNode = target.closest('.field_with_errors')
      const children = Array.from(errorNode.childNodes)
      errorNode.replaceWith(...children)
    }
    if (errorId) {
      document.querySelectorAll('[data-field-error="' + errorId + '"]').forEach(element => {
        element.remove()
      })
    }
  }
}